import { CATEGORIES, CATEGORY_META } from "./categories.js";

const ICE = {
  politics: "#7aa2ff",
  sports: "#5ee0c8",
  finance: "#e8c47a",
  crypto: "#f0a35e",
  history: "#9b8cff",
  science: "#6ec8ff",
  technology: "#4d9fff",
  health: "#7dffb3",
  culture: "#ff9ecf",
  environment: "#6fd98a",
  law: "#a8b4c8",
  education: "#8fd3ff",
  entertainment: "#ffb07a",
  military: "#6a7aaa",
  religion: "#c9b6ff",
};

export const THEMES = {
  polaris: {
    id: "polaris",
    label: "Polaris",
    blurb: "Bright ice field",
    bg: 0x07080c,
    fog: 0.0048,
    wash: [0.92, 0.96, 1.0],
    lineAlpha: 0.16,
    grid: [0.55, 0.72, 0.95],
    gridAlpha: 0.18,
    marker: 0xe8c47a,
    pointScale: 1,
    stars: {
      mode: "bright",
      tint: [0.82, 0.88, 1.0],
      brightness: 1,
      size: 0.9,
      opacity: 0.72,
    },
    categoryColors: ICE,
    ui: {
      bg: "#07080c",
      panel: "rgba(10, 14, 22, 0.78)",
      stroke: "rgba(158, 203, 255, 0.16)",
      text: "#e8eefc",
      muted: "#8b97b3",
      accent: "#9ecbff",
      gold: "#e8c47a",
      swatch: "#9ecbff",
    },
  },
  ashen: {
    id: "ashen",
    label: "Ashen",
    blurb: "Dusty dim stars",
    bg: 0x050506,
    fog: 0.0072,
    wash: [0.72, 0.74, 0.76],
    lineAlpha: 0.11,
    grid: [0.42, 0.44, 0.48],
    gridAlpha: 0.1,
    marker: 0xc8c2b4,
    pointScale: 0.92,
    stars: {
      mode: "dust",
      tint: [0.62, 0.6, 0.55],
      brightness: 0.38,
      size: 0.55,
      opacity: 0.4,
    },
    categoryColors: {
      politics: "#8a93a6",
      sports: "#7ea090",
      finance: "#c2b089",
      crypto: "#b89a78",
      history: "#8e86a0",
      science: "#86a0b0",
      technology: "#6f88a0",
      health: "#87b39a",
      culture: "#b0909e",
      environment: "#7ea686",
      law: "#9aa0aa",
      education: "#8eacbc",
      entertainment: "#b89a80",
      military: "#6d7380",
      religion: "#a89ab0",
    },
    ui: {
      bg: "#050506",
      panel: "rgba(16, 16, 18, 0.82)",
      stroke: "rgba(200, 194, 180, 0.16)",
      text: "#e6e2da",
      muted: "#8d8a84",
      accent: "#c8c2b4",
      gold: "#c2b089",
      swatch: "#c8c2b4",
    },
  },
  crimson: {
    id: "crimson",
    label: "Crimson",
    blurb: "Warm house palette",
    bg: 0x0c0708,
    fog: 0.0052,
    wash: [1.0, 0.86, 0.82],
    lineAlpha: 0.15,
    grid: [0.72, 0.28, 0.32],
    gridAlpha: 0.14,
    marker: 0xff6b6b,
    pointScale: 1.02,
    stars: {
      mode: "ember",
      tint: [1.0, 0.62, 0.48],
      brightness: 0.7,
      size: 0.8,
      opacity: 0.58,
    },
    categoryColors: {
      politics: "#ff6b6b",
      sports: "#ff9f68",
      finance: "#e8c47a",
      crypto: "#ff7a45",
      history: "#c45c6a",
      science: "#ff8a9a",
      technology: "#e05a5a",
      health: "#ffb3a0",
      culture: "#ff7aa2",
      environment: "#d98a6a",
      law: "#c9a0a0",
      education: "#f0a0a8",
      entertainment: "#ffb07a",
      military: "#8a4048",
      religion: "#e8a0b4",
    },
    ui: {
      bg: "#0c0708",
      panel: "rgba(24, 10, 12, 0.8)",
      stroke: "rgba(255, 107, 107, 0.2)",
      text: "#ffe8e6",
      muted: "#b38b8b",
      accent: "#ff8a8a",
      gold: "#e8c47a",
      swatch: "#ff6b6b",
    },
  },
  ion: {
    id: "ion",
    label: "Ion",
    blurb: "Electric cyan field",
    bg: 0x04060e,
    fog: 0.0044,
    wash: [0.75, 0.95, 1.0],
    lineAlpha: 0.2,
    grid: [0.2, 0.9, 1.0],
    gridAlpha: 0.2,
    marker: 0x5ef0ff,
    pointScale: 1.06,
    stars: {
      mode: "bright",
      tint: [0.55, 0.95, 1.0],
      brightness: 1.05,
      size: 1.05,
      opacity: 0.78,
    },
    categoryColors: {
      politics: "#5b8cff",
      sports: "#3dffd2",
      finance: "#ffe56b",
      crypto: "#ff7ad9",
      history: "#a78bff",
      science: "#5ef0ff",
      technology: "#3d9dff",
      health: "#6dffc2",
      culture: "#ff6bdc",
      environment: "#4dff9a",
      law: "#8ec0ff",
      education: "#7af0ff",
      entertainment: "#ff9a6b",
      military: "#4a6aa0",
      religion: "#d0a0ff",
    },
    ui: {
      bg: "#04060e",
      panel: "rgba(6, 12, 24, 0.8)",
      stroke: "rgba(94, 240, 255, 0.2)",
      text: "#d9fbff",
      muted: "#6f97a8",
      accent: "#5ef0ff",
      gold: "#ffe56b",
      swatch: "#5ef0ff",
    },
  },
  helios: {
    id: "helios",
    label: "Helios",
    blurb: "Solar gold",
    bg: 0x0b0906,
    fog: 0.005,
    wash: [1.0, 0.94, 0.78],
    lineAlpha: 0.15,
    grid: [0.9, 0.72, 0.32],
    gridAlpha: 0.15,
    marker: 0xffd56a,
    pointScale: 1.04,
    stars: {
      mode: "bright",
      tint: [1.0, 0.9, 0.65],
      brightness: 0.95,
      size: 0.95,
      opacity: 0.7,
    },
    categoryColors: {
      politics: "#e8b86a",
      sports: "#d7e07a",
      finance: "#ffd56a",
      crypto: "#ff9a3d",
      history: "#c4a06a",
      science: "#f0d48a",
      technology: "#e0a04a",
      health: "#c8e08a",
      culture: "#ffb0a0",
      environment: "#b8d07a",
      law: "#d8c8a0",
      education: "#f0d8a0",
      entertainment: "#ffc07a",
      military: "#8a7048",
      religion: "#e8c8a8",
    },
    ui: {
      bg: "#0b0906",
      panel: "rgba(22, 16, 8, 0.8)",
      stroke: "rgba(255, 213, 106, 0.2)",
      text: "#fff4dc",
      muted: "#a89470",
      accent: "#ffd56a",
      gold: "#ffd56a",
      swatch: "#ffd56a",
    },
  },
  nebula: {
    id: "nebula",
    label: "Nebula",
    blurb: "Violet cloud",
    bg: 0x08060f,
    fog: 0.0055,
    wash: [0.94, 0.86, 1.0],
    lineAlpha: 0.17,
    grid: [0.72, 0.48, 1.0],
    gridAlpha: 0.16,
    marker: 0xe0a0ff,
    pointScale: 1.03,
    stars: {
      mode: "dust",
      tint: [0.86, 0.7, 1.0],
      brightness: 0.55,
      size: 0.7,
      opacity: 0.5,
    },
    categoryColors: {
      politics: "#8a7aff",
      sports: "#7ae0d2",
      finance: "#ffd27a",
      crypto: "#ff8ad4",
      history: "#b48aff",
      science: "#9ad0ff",
      technology: "#7a9aff",
      health: "#9affc8",
      culture: "#ff8ad4",
      environment: "#8affb0",
      law: "#c0b4e0",
      education: "#b0d0ff",
      entertainment: "#ffb0d0",
      military: "#6a5a90",
      religion: "#e0b0ff",
    },
    ui: {
      bg: "#08060f",
      panel: "rgba(16, 10, 26, 0.8)",
      stroke: "rgba(196, 150, 255, 0.2)",
      text: "#f3e9ff",
      muted: "#9a8ab8",
      accent: "#d0a0ff",
      gold: "#ffd27a",
      swatch: "#d0a0ff",
    },
  },
};

export const THEME_ORDER = ["polaris", "ashen", "crimson", "ion", "helios", "nebula"];
export const DEFAULT_THEME_ID = "polaris";
const STORAGE_KEY = "semantic-galaxy-theme";

export function getTheme(id) {
  return THEMES[id] || THEMES[DEFAULT_THEME_ID];
}

export function loadThemeId() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && THEMES[stored]) return stored;
  } catch {
    return DEFAULT_THEME_ID;
  }
  return DEFAULT_THEME_ID;
}

export function saveThemeId(id) {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    return;
  }
}

export function themeCategoryMeta(theme) {
  const meta = {};
  for (const key of CATEGORIES) {
    meta[key] = {
      label: CATEGORY_META[key].label,
      color: theme.categoryColors[key] || CATEGORY_META[key].color,
    };
  }
  return meta;
}

export function applyThemeToDocument(theme) {
  const root = document.documentElement;
  root.dataset.theme = theme.id;
  root.style.setProperty("--bg", theme.ui.bg);
  root.style.setProperty("--panel", theme.ui.panel);
  root.style.setProperty("--stroke", theme.ui.stroke);
  root.style.setProperty("--text", theme.ui.text);
  root.style.setProperty("--muted", theme.ui.muted);
  root.style.setProperty("--accent", theme.ui.accent);
  root.style.setProperty("--gold", theme.ui.gold);
  document.body.style.background = theme.ui.bg;
}
